import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { injectIntl } from 'react-intl';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import Checkbox from 'material-ui/Checkbox';
import Divider from 'material-ui/Divider';
import { grey400 } from 'material-ui/styles/colors';
import getTranslatedText from '../../../../../../../../services/getTranslatedText';
import UpdateReportConfigMutation from '../../../../../../../../mutations/UpdateReportConfigMutation';
import _ from 'lodash';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { DEFAULT_LOCALE } from '../../../../../../../../constants';



function getStateFromProps(props) {
  return {
    isAccountAdmin: !!(props.isAccountAdmin || false),
    name: props.report.name || '',
    folder: props.report.folder || '',
    groupByLocation: !!props.report.groupByLocation,
    showTagsFilter: !!props.report.showTagsFilter,
    selectedDevices: _.map(props.report.devices, 'id'),
    filters: props.report.filters && props.report.filters.map((filter) => {
      return Object.assign({}, filter, { text: getTranslatedText(filter.text, props.intl.locale) });
    }),
  };
}

const styles = {
  reportNameInput: {
    width: 500,
  },
  folderInput: {
    width: 500,
  },
  formLabel: {
    color: grey400,
    display: 'block',
    fontSize: '16px',
    lineHeight: '22px',
    margin: '40px 0 10px',
  },
  groupByLocationToggle: {
    margin: '40px 0 40px',
  },
  showTagsFilterToggle: {
    margin: '40px 0 10px',
  },
  deviceListAll: {
    marginBottom: 10,
  },
  deviceListDivider: {
    marginBottom: 10,
    width: 300,
  },
  deviceListItem: {
    marginTop: 5,
    marginBottom: 5,
  },
  filterTextInput: {
    width: 500,
    marginTop: -10,
  },
};

@injectIntl
class EditReportDialog extends Component {
  constructor(props) {
    super(props);
    this.state = getStateFromProps(props);
  }

  updateName = (event, value) => {
    this.setState({ name: value });
  };

  updateFolder = (event, value) => {
    this.setState({ folder: value });
  };

  updateGroupByLocation = (event, groupByLocation) => {
    this.setState({ groupByLocation });
  };

  updateShowTagsFilter = (event, showTagsFilter) => {
    this.setState({ showTagsFilter });
  };

  updateSelectedDevices = (deviceId, checked) => {
    const newSelectedDevices = checked
      ? _.union(this.state.selectedDevices, [deviceId])
      : _.without(this.state.selectedDevices, deviceId);

    if (newSelectedDevices.length === (this.props.devices && this.props.devices.length)) {
      this.setState({ selectedDevices: [] });
    } else {
      this.setState({ selectedDevices: newSelectedDevices });
    }
  };

  selectAllDevices = () => {
    this.setState({ selectedDevices: [] });
  };

  updateFilterText = (questionId, value) => {
    this.setState({
      filters: this.state.filters.map((filter) => {
        if (filter.question.mongoId === questionId) {
          return Object.assign({}, filter, { text: value });
        } else {
          return filter;
        }
      }),
    });
  };

  save = () => {
    const filters = this.state.filters && this.state.filters.map((filter) => {

      let overrides = {
        question: filter.question.mongoId,
      };

      if (!filter.text) {
        overrides.text = null;
      }

      if (typeof filter.text === 'string') {
        filter.text = [{
          text: filter.text,
          language: DEFAULT_LOCALE,
        }];
      }

      return Object.assign({}, filter, overrides);
    });

    UpdateReportConfigMutation.commit({
      reportId: this.props.report.id,
      name: this.state.name,
      folder: this.state.folder,
      groupByLocation: this.state.groupByLocation,
      showTagsFilter: this.state.showTagsFilter,
      devices: this.state.selectedDevices,
      filters: filters || [],
    },
      (error, data) => {
        if (!!this.props.onSubmit && typeof this.props.onSubmit === 'function') {
          this.props.onSubmit();
        }
      });
    this.props.onClose();
  };

  cancel = () => {
    this.setState(getStateFromProps(this.props));
    this.props.onClose();
  };

  handleLockChange = (values, index) => {
    const filters = this.state.filters;
    filters[index].locked = values;
    this.setState({ filters });
  };

  render() {

    const accountDeviceEdges = (this.props.devices && this.props.devices.edges) || [];
    const accountDevices = accountDeviceEdges.map(edge => edge.node).filter(d => d.name !== 'Demo');

    const dialogActions = [
      <FlatButton
        label="Cancel"
        onTouchTap={this.cancel}
      />,
      <RaisedButton
        label="Save"
        primary={true}
        onTouchTap={this.save}
      />,
    ];

    return (
      <Dialog
        title="Edit report"
        open={this.props.open}
        autoScrollBodyContent={true}
        actions={dialogActions}
        onRequestClose={this.cancel}
      >
        <TextField
          floatingLabelText="Report Name"
          value={this.state.name}
          onChange={this.updateName}
          style={styles.reportNameInput}
        />

        <TextField
          floatingLabelText="Folder"
          value={this.state.folder}
          onChange={this.updateFolder}
          style={styles.folderInput}
        />

        <Toggle
          label="Group devices by location"
          labelPosition="right"
          toggled={this.state.groupByLocation}
          onToggle={this.updateGroupByLocation}
          style={styles.groupByLocationToggle}
        />

        <Toggle
          label="Show tags filter"
          labelPosition="right"
          toggled={this.state.showTagsFilter}
          onToggle={this.updateShowTagsFilter}
          style={styles.showTagsFilter}
        />

        <label style={styles.formLabel}>
          Devices to include in report:
        </label>
        <Checkbox
          label="All"
          checked={this.state.selectedDevices && this.state.selectedDevices.length <= 0}
          onCheck={this.selectAllDevices}
          style={styles.deviceListAll}
        />
        <Divider style={styles.deviceListDivider} />
        {accountDevices.map(device =>
          <Checkbox
            key={device.id}
            label={device.name}
            checked={_.includes(this.state.selectedDevices, device.id)}
            onCheck={(event, checked) => this.updateSelectedDevices(device.id, checked)}
            style={styles.deviceListItem}
          />
        )}

        {this.props.report.filters && this.props.report.filters.length > 0 && (
          <div>
            <label style={styles.formLabel}>
              Override filter titles:
            </label>
            {this.state.filters.map(filter =>
              <TextField
                key={filter.question.mongoId}
                floatingLabelText={getTranslatedText(filter.question.text, this.props.intl.locale)}
                value={filter.text}
                onChange={(event, value) => this.updateFilterText(filter.question.mongoId, value)}
                style={styles.filterTextInput}
              />
            )}
          </div>
        )}

        {this.props.isAccountAdmin && this.props.report.filters && this.props.report.filters.length > 0 && (
          <div>
            <h4 style={{
              marginTop: '2.5em',
              marginBottom: 0,
            }}>
              Lock filter options
            </h4>

            {this.state.filters.map((filter, filterIndex) =>
              <SelectField
                key={`lock-select-field-${filter.question.mongoId}}`}
                multiple={true}
                value={filter.locked}
                onChange={(event, index, values) => this.handleLockChange(values, filterIndex)}
                autoWidth={true}
                style={{
                  width: '100%',
                }}
                floatingLabelText={getTranslatedText(filter.question.text, this.props.intl.locale)}
              >
                {(filter.question.options || []).map(option =>
                  <MenuItem
                    key={`lock-menu-item-${filter.question.mongoId}-${option.value}`}
                    value={option.value}
                    primaryText={getTranslatedText(option.text, this.props.intl.locale)}
                    insetChildren={true}
                    checked={filter.locked && filter.locked.indexOf(option.value) > -1}
                  />
                )}
              </SelectField>
            )}

          </div>
        )}

      </Dialog>
    );
  }
}

export default createFragmentContainer(
  EditReportDialog,
  graphql`
    fragment EditReportDialog_report on Report {
      id
      name
      folder
      devices {
        id
        name
      }
      filters {
        type
        text {
          language
          text
        }
        question {
          mongoId
          text {
            language
            text
          }
          options {
            value
            text {
              language
              text
            }
          }
        }
        locked
      }
      groupByLocation
      showTagsFilter
    }
    fragment EditReportDialog_devices on DeviceConnection {
      edges {
        node {
          id
          name
        }
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/EditReportDialog/EditReportDialog.js